import {CompetitionSeason} from './CompetitionSeason';
import {Profile} from './Profile';
import {TeamSeason} from './TeamSeason';
import type {Iso8601DateString} from '@fupa/fupa-ts-core';

interface CompetitionSeasonTopScorer {
  readonly id: number;
  readonly player: Profile;
  readonly team: TeamSeason;
}

export class CompetitionSeasonTopScorers {
  readonly id: number;
  readonly competition: CompetitionSeason;
  readonly firstScorer: CompetitionSeasonTopScorer | null;
  readonly secondScorer: CompetitionSeasonTopScorer | null;
  readonly thirdScorer: CompetitionSeasonTopScorer | null;
  readonly createdAt: Iso8601DateString;
}
